import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import {PaperInputBehavior} from "@polymer/paper-input/paper-input-behavior";
import {IronFormElementBehavior} from "@polymer/iron-form-element-behavior/iron-form-element-behavior";
import {mixinBehaviors} from "@polymer/polymer/lib/legacy/class";
import "@polymer/paper-input/paper-input-container.js";
import "@polymer/paper-input/paper-input-error.js";
import "@polymer/iron-input/iron-input.js";

/**
 * `cbar-input`
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarInput extends mixinBehaviors([PaperInputBehavior, IronFormElementBehavior], PolymerElement) {
  static get template() {
    return html`
    <style is="custom-style">
      cbar-input, input{
        width: 100%;
        font-size: 16px;
        font-weight: 400;
      }
      /* fixes DW style overriding */
      cbar-input, input, input:focus{
        outline: none;
        border: none;
        box-shadow: none;
      }
      input, input:focus{
      background: transparent;
      }
      label{
      text-align: left;
      font-weight: normal;
      padding: 0;
      }
    </style>

    <paper-input-container invalid="{{invalid}}">
      <label slot="label">{{label}}</label>
      <iron-input id$="[[_inputId]]" bind-value="{{value}}" slot="input" error-message="[[errorMessage]]" invalid="{{invalid}}" label="{{label}}">
        <input readonly$="[[readonly]]" type$="[[type]]" autofocus required$="[[required]]" placeholder$="[[placeholder]]" autocapitalize="[[autocapitalize]]" autocomplete="[[autocomplete]]"/>
      </iron-input>

      <template is="dom-if" if="[[errorMessage]]">
        <paper-input-error aria-live="assertive" slot="add-on">[[errorMessage]]</paper-input-error>
      </template>
    </paper-input-container>
    `;
  }

  constructor() {
    super();

    // Setting to readonly for a short period to avoid
    // browser autocompletion. autocomplete="off" doesn't work.
    this.readonly = true;
  }

  static get is() {
    return 'cbar-input';
  }

  _attachDom(dom) {
    // No shadow dom
    this.appendChild(dom);
  }

  ready() {
    super.ready();
    this.root = this;

    setTimeout(() => {
      this.readonly = false;
    }, 1);

    let ob = new MutationObserver(() => {
      this.checkClasses(this);
    });

    ob.observe(this, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  /**
   *
   * @param HTML element
   */
  checkClasses(element){
    let containsFocusClass = element.classList.contains('focus-visible');
    let input = this.querySelector('input');

    if(containsFocusClass){
      input.focus();
    }
  }
}

window.customElements.define(CbarInput.is, CbarInput);
